import React from 'react';
import './index.css';
import Home from './components/home/home';
import Login from './components/login/login';
import portalRoutes from './routes/portal.routes';
import ChatPage from './pages/chatbot/ChatPage';
import PrivateRoute from './routes/PrivateRoute';
import { useRoutes } from 'react-router-dom';
import Forbidden from './pages/Forbidden';
import ContactUs from './components/home/contactus/ContactUs';
import AboutUs from './components/home/AboutUs/AboutUs';
import Security from './components/home/Security/Security';
import Solutions from './components/home/Solutions/Solutions';
import AgentStudio from './components/home/AgentStudio/AgentStudio';
import SelficWorkflows from './components/home/SelficWorkflows/SelficWorkflows';
import ApplicationListing from './pages/portal/applications/components/ApplicationListings';
import AppViewer from './pages/portal/applications/components/AppViewer';
import ChatAgentGenerator from './pages/portal/chatagents/new/ChatAgentsLayout';
import ConversationGraphBuilder from './pages/portal/chatagents/new/ChatIntents/ConversationGraphBuilder';
import HomeGate from './routes/HomeGate';
import AuthCallback from './pages/auth/AuthCallback';
import EntraComplete from './pages/auth/EntraComplete';
import WorkflowRunHtmlViewerPage from './pages/workflowRunHtmlViewer/WorkflowRunHtmlViewerPage';
import OpsConsolePage from './pages/opsConsole/OpsConsolePage';

const wrapAdmin = (element: React.ReactElement) => (
  <PrivateRoute requireAdmin={true}>{element}</PrivateRoute>
);

const App = () => {
  const routes = useRoutes([
    { path: '/', element: <HomeGate /> },
    // { path: '/home', element: <Home /> },
    { path: '/contactus', element: <ContactUs /> },
    { path: '/security', element: <Security /> },
    { path: '/selficworkflows', element: <SelficWorkflows /> },
    { path: '/solutions', element: <Solutions /> },
    { path: 'createChatIntent', element: <ConversationGraphBuilder /> },
    { path: '/agentstudio', element: <AgentStudio /> },
    { path: '/aboutus', element: <AboutUs /> },
    { path: 'chatbot', element: <ChatAgentGenerator /> },
    { path: '/home', element: <HomeGate /> },
    {
      path: 'app/:appcode',
      element: <AppViewer />,
    },
    { path: '/login', element: <Login /> },
    { path: '/auth/callback', element: <AuthCallback /> },
    { path: '/auth/entra/complete', element: <EntraComplete /> },
    { path: '/ops-console', element: <OpsConsolePage /> },
    {
      path: '/workflow-run-html/:workflowId/:runId/:nodeId',
      element: (
        <PrivateRoute requireAdmin={false}>
          <WorkflowRunHtmlViewerPage />
        </PrivateRoute>
      ),
    },
    { path: '/forbidden', element: <Forbidden /> },
    {
      path: '/chat',
      element: (
        <PrivateRoute requireAdmin={false}>
          <ChatPage />
        </PrivateRoute>
      ),
    },
    portalRoutes
    // {
    //   path: '/portal',
    //   element: (
    //     <PrivateRoute requireAdmin>
    //       {portalRoutes.element  as React.ReactElement}
    //     </PrivateRoute>
    //   ),
    //   children: portalRoutes.children, // ✅ Attach children routes here
    // },
  ]);

  return routes;
};

export default App;
